import styled from 'styled-components';

const FlagContainer = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${({ theme }) => theme?.spacing?.medium || '0.9375rem'};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */

  @media (max-width: ${({ theme }) => theme?.breakpoints?.mobile || '768px'}) {
    width: 40px;
    height: 40px;
    margin-right: ${({ theme }) => theme?.spacing?.small || '0.625rem'};
  }
`;

export default FlagContainer;
